"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGlobalStyle = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_dom_1 = require("react-dom");
const styled_components_1 = require("styled-components");
const globalStyles = new Map();
let element;
const ensureElementReady = () => {
    if (!element) {
        if (typeof window !== 'undefined') {
            element = window.document.createElement('div');
            window.document.head.appendChild(element);
        }
        else {
            console.warn('No document to render global styles');
        }
    }
};
const useDedupedStyleRendering = (key, styleElement) => {
    const shouldUpdateStyles = !globalStyles.has(key);
    if (shouldUpdateStyles) {
        globalStyles.set(key, styleElement);
    }
    (0, react_1.useEffect)(() => {
        if (shouldUpdateStyles && element) {
            const list = Array.from(globalStyles).map((entry) => entry[1]);
            (0, react_dom_1.render)(react_1.default.createElement(react_1.default.Fragment, null, list), element);
        }
    }, [shouldUpdateStyles]);
};
function createDedupedGlobalStyle(first, ...interpolations) {
    const GlobalStyle = (0, styled_components_1.createGlobalStyle)(first, ...interpolations);
    return ({ id }) => {
        const theme = (0, styled_components_1.useTheme)();
        ensureElementReady();
        useDedupedStyleRendering(id, react_1.default.createElement(GlobalStyle, { key: id, theme: theme }));
        return null;
    };
}
exports.createGlobalStyle = createDedupedGlobalStyle;
//# sourceMappingURL=createDedupedGlobalStyle.js.map